import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { Element } from '../../../../common/html/element'
import { Icon } from '../../../../common/html/icon'
import { PopupAction } from '../../../../common/popup/PopupAction'
import ButtonSubmit from './ButtonSubmit'
import CheckOutScreen from './CheckOutScreen'
import PanelList from './PanelList'
import SettingLayout from './SettingLayout'
import SettingPanel from './SettingPanel'
import TemplateName from './TemplateName'
import classes from './index.module.scss'
import {
  addDefaultTemplate,
  resetDefault,
  selectDefaultTemplate,
} from './store/slice'

const DetailTemplate = ({ handleBack, goToTemplateTable, detailTemplate }) => {
  const dispatch = useDispatch()

  const {
    getPanels,
    formatDefaultPanel,
    renderSettingPanel,
    saveTemplate,
    apply,
    getCurrentTemplate,
    currentTemplate,
  } = detailTemplate

  const defaultTemplate = useSelector(selectDefaultTemplate)

  const [isShowPopupReset, setIsShowPopupReset] = useState(false)

  useEffect(() => {
    if (defaultTemplate.templateId) {
      getCurrentTemplate(defaultTemplate.templateId)
    }
  }, [defaultTemplate.templateId])

  useEffect(() => {
    dispatch(addDefaultTemplate(currentTemplate))
  }, [currentTemplate])

  const reset = () => {
    dispatch(resetDefault())
    setIsShowPopupReset(false)
  }

  return (
    <Element style={{ color: '#3A414B' }} className={classes.preferenceSetting}>
      <div className={classes.header}>
        <div>
          <Element
            style={{ border: '1px solid #D5D5D5' }}
            className={classes.btnBack}
            onClick={handleBack}
          >
            <Icon className="icon-arrow-left" style={{ fontSize: 8 }} />
            <Translate value="preferenceSetting.BACK_PAGE" />
          </Element>
          <Element
            style={{ fontSize: 24, color: '#0553A5' }}
            className={classes.title}
          >
            <Translate value="preferenceSetting.PREFERENCE_SETTING" />
          </Element>
        </div>
        <Element
          style={{ border: '1px solid #6D9DCF', color: '#0553A5' }}
          className={classes.btnTemplate}
          onClick={goToTemplateTable}
        >
          <Icon
            style={{ color: '#0553A5', fontSize: 13 }}
            className="icon-folder"
          />
          <Translate value="preferenceSetting.SAVED_TEMPLATE" />
        </Element>
      </div>
      <div className={classes.information}>
        <TemplateName />
        <Element
          style={{ border: '1px solid #6D9DCF', color: '#0553A5' }}
          className={classes.btnReset}
          onClick={() => setIsShowPopupReset(true)}
        >
          <Icon
            style={{ color: '#0553A5', fontSize: 13 }}
            className="icon-reset2"
          />
          <Translate value="preferenceSetting.RESET" />
        </Element>
      </div>
      <div className={classes.contentContainer}>
        <Element className={classes.contentBorder}>
          <Element
            style={{ background: '#F3F3F3' }}
            className={classes.contentPanel}
          >
            <PanelList
              getPanels={getPanels}
              formatDefaultPanel={formatDefaultPanel}
            />
          </Element>
          <div className={classes.contentPanel}>
            <SettingLayout />
          </div>
          <div className={classes.contentPanel}>
            <SettingPanel renderSettingPanel={renderSettingPanel} />
          </div>
        </Element>
      </div>
      <div className={classes.groupBtn}>
        <Element
          style={{ border: '1px solid #D5D5D5' }}
          className={classes.btnBack}
          onClick={handleBack}
        >
          <Translate value="preferenceSetting.BACK_PAGE" />
        </Element>
        <ButtonSubmit
          saveTemplate={saveTemplate}
          goToTemplateTable={goToTemplateTable}
          apply={apply}
        />
      </div>
      <PopupAction
        isShow={isShowPopupReset}
        title="preferenceSetting.CONFIRMATION_2"
        handleClose={() => setIsShowPopupReset(false)}
        btnCancel={{
          label: 'common.NO',
          event: () => setIsShowPopupReset(false),
          isI18n: true,
        }}
        btnSubmit={{
          label: 'common.YES',
          event: reset,
          isI18n: true,
        }}
      >
        <Translate value="preferenceSetting.RESET_TEMPLATE" />
      </PopupAction>
      <CheckOutScreen saveTemplate={saveTemplate} />
    </Element>
  )
}

export default DetailTemplate
